<template>
  <v-dialog
      width="500"
      v-model="dialogShow"
  >
    <v-card>
      <v-card-title class="text-h5 grey lighten-2">
        <h3>Purchasable Nft</h3>
        <v-spacer></v-spacer>
        <v-btn
            color="primary"
            text
            @click="dialogShow = false"
        >
          Close
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-2">
        <div class="d-flex justify-center mb-6">
          <div class="w-66">
            <v-img
                aspect-ratio="1"
                contain
                :src="nft.imageUrl">
            </v-img>
          </div>
        </div>

        <div class="d-flex justify-space-between">
          <div>Nft Contract:</div>
          <div>{{ nft.contract }}</div>
        </div>

        <div class="d-flex justify-space-between">
          <div>Token Id:</div>
          <div>{{ nft.tokenId }}</div>
        </div>

        <div class="d-flex justify-space-between mt-4">
          <div>Name:</div>
          <div>{{ nft.name }}</div>
        </div>

        <div class="d-flex justify-space-between">
          <div>External Url:</div>
          <div>{{ nft.externalUrl }}</div>
        </div>

        <div class="mt-4 mb-2">
          <div>Description:</div>
          {{ nft.description }}
        </div>

        <h5>Attributes:</h5>
        <v-sheet
            color="grey lighten-3"
            class="pa-2 mt-2"
            v-for="(trait, index) in nft.attributes"
            :key="index"
        >
          <div class="d-flex justify-space-between">
            <div>
              {{ trait.trait_type }}
            </div>
            <div>
              {{ trait.value }}
            </div>
          </div>
        </v-sheet>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: "NftMetadataDialog",
  props: {
    nft: Object,
    onCloseDialogHandle: Function
  },
  watch: {
    dialogShow(){
      this.onCloseDialogHandle()
    }
  },
  data(){
    return {
      dialogShow: true
    }
  }
}
</script>

<style scoped>

</style>